module.exports = __webpack_public_path__ + "img/logo.2d99c6a4.png";